import React, { useState, useEffect } from "react";
import Alert from "react-bootstrap/Alert"
import { Button, Icon } from "semantic-ui-react";
import { useStore } from "../../../app/stores/store";
import { Formik, Form, Field, useFormik } from "formik";
import * as Yup from "yup";
import { observer } from "mobx-react-lite";
import { Movimiento, MovimientoFormValues } from "../../../app/models/CCTMovimientoCreate";

interface Props {
    userId: string;
    cuenta: string;
    catEdicionesId: number;
    movimiento: MovimientoFormValues;
    updateCourseList: () => void;
}

export default observer(function ModalEditarMovimiento(props: Props){

  const {modalStore, CCTMovimientoStore} = useStore();

  const [showOptions, setShowOptions] = useState(true);
  const [showRevert, setShowRevert] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  function revertirMovimiento(justificacion: string){
    const now = new Date();
    let movimiento = {
      idCliente: props.userId,
      cuenta: props.cuenta,
      codigoTipoTransaccion: 21,
      numeroTransaccion: props.movimiento.numeroTransaccion,
      fecha: now,
      valor: props.movimiento.valor,
      estatusMovimiento: "AC",
      usuarioRegistro: "",
      fechaRegistro: now,
      usuarioAnulo: "",
      fechaAnulado: "",
      numeroDeDocumentoContable: 0,
      pagado: props.movimiento.pagado,
      justificacion: justificacion
    };

    CCTMovimientoStore.createCCTMovimiento(movimiento).then( () => {
      modalStore.closeModal()
      props.updateCourseList()
    })
  }

  const validarReversion = Yup.object ({
    descripcion: Yup.string()
      .required("Por favor escribe una descripción")
      .max(150, "Por favor escribe una descripción más corta.")
  })

  const validarValor = Yup.object ({
    valorNuevo: Yup.number()
      .required("Por favor escribe un valor nuevo.")
  })

  function editarValor(valorNuevo: number){

    let movimiento = {
      idCliente: props.userId,
      cuenta: props.cuenta,
      codigoTipoTransaccion: props.movimiento.codigoTipoTransaccion,
      numeroTransaccion: props.movimiento.numeroTransaccion,
      fecha: props.movimiento.fecha,
      valor: valorNuevo,
      estatusMovimiento: props.movimiento.estatusMovimiento,
      usuarioRegistro: "",
      fechaRegistro: props.movimiento.fechaRegistro,
      usuarioAnulo: "",
      fechaAnulado: "",
      numeroDeDocumentoContable: props.movimiento.numeroDeDocumentoContable,
      pagado: props.movimiento.pagado
    };

    CCTMovimientoStore.editCCTMovimiento(props.userId, props.cuenta, props.movimiento.codigoTipoTransaccion, props.movimiento.numeroTransaccion, movimiento).then( () => {
        modalStore.closeModal();
        props.updateCourseList();
    })
  }

    return(
        <div className="modal_pago_cur modal-reset-password">
        <div className="modal_pago_head">
          <h1>Editar movimiento</h1>
        </div>

          {showOptions && ( //mostrar botones para escoger operacion
            <div className="contenedor_opciones_editar">
              <p style={{margin:"10px"}}>Escoge los datos a editar del movimiento:</p>
              <div className="contenedor_botones_editar">
                <Button 
                    animated = "vertical"
                    style ={{width:"150px", margin:"10px"}}
                    circular
                    color= "blue"
                    size="medium"
                    onClick={() => {
                      setShowRevert(true);
                    setShowOptions(false);
                    }}>
                    <Button.Content hidden><Icon name="undo"/></Button.Content>
                    <Button.Content visible>Revertir</Button.Content>
                </Button>
                <Button 
                    animated = "vertical"
                    style ={{width:"150px", margin:"10px"}}
                    circular
                    color= "green"
                    size="medium"
                    onClick={() => {
                      setShowEdit(true);
                    setShowOptions(false);
                    }}>
                    <Button.Content hidden><Icon name="edit"/></Button.Content>
                    <Button.Content visible>Editar valor</Button.Content>
                </Button>
              </div>
            </div>
          )}
          
          {showRevert && ( //mostrar confirmacion para revertir
            <Formik
            enableReinitialize
            
            initialValues={{descripcion: ""}}
            onSubmit={(values) => {
              revertirMovimiento(values.descripcion);
            }}
            validationSchema={validarReversion}
            >
            {({ handleSubmit, isValid, isSubmitting, dirty, values, errors, touched}) => (
              <Form
              onSubmit={handleSubmit}
              autoComplete="off"
              className="contenido_modal_pago"
            >
              <div style={{margin:"30px", marginBottom:"10px"}}>
                <label htmlFor="descripcion" style={{marginTop:"10px", width: "100%", fontSize:"12pt"}}>
                      Por favor escribe una justificación para la reversión:
                    </label>
                    <Field type="text"
                      id="descripcion" 
                      name="descripcion" 
                      placeholder=""
                      style={{width:"100%", marginBottom: "5px"}}
                      />
                      {errors.descripcion && touched.descripcion ? (
                        <Alert variant="danger">{errors.descripcion}</Alert>
                      ) : null}
                <div className="contenedor_flex">
                  <Button
                    loading={CCTMovimientoStore.loading}
                    content={"Cancelar"}
                    className="gray"
                    onClick={modalStore.closeModal}
                  />
                  <Button
                    loading={CCTMovimientoStore.loading}
                    type="submit"
                    content={"Confirmar"}
                    className="blue"
                  />
                </div>
              </div>
            </Form>
            )}
          </Formik>
          )}

          {showEdit && ( //mostrar campo para editar valor
            <Formik
            enableReinitialize
            
            initialValues={{valorNuevo: ""}}
            onSubmit={(values) => {
              editarValor(parseFloat(values.valorNuevo));
            }}
            validationSchema={validarValor}
            >
            {({ handleSubmit, isValid, isSubmitting, dirty, values, errors, touched}) => (
              <Form
              onSubmit={handleSubmit}
              autoComplete="off"
              className="contenido_modal_pago">
                <div style={{margin: "30px", marginBottom:"10px"}}>
                  <label htmlFor="valorNuevo" style={{marginTop:"10px", width: "100%", fontSize:"12pt"}}>
                    Ingresa el nuevo valor para el movimiento:
                  </label>
                  <Field type="number"
                    id="valorNuevo" 
                    name="valorNuevo" 
                    placeholder=""
                    style={{width:"100%", marginBottom: "5px"}}
                    />
                    {errors.valorNuevo && touched.valorNuevo ? (
                      <Alert variant="danger">{errors.valorNuevo}</Alert>
                    ) : null}
                  <div className="contenedor_flex">
                    <Button
                      loading={CCTMovimientoStore.loading}
                      content={"Cancelar"}
                      className="gray"
                      onClick={modalStore.closeModal}
                    />
                    <Button
                      loading={CCTMovimientoStore.loading}
                      type="submit"
                      content={"Enviar"}
                      className="blue"
                    />
                  </div>
                </div>
              </Form>
            )}
            </Formik>
          )}
    </div>
    )
})